import mixins from 'synergycms_core/src/less/mixins';

export default {
  content: {},
  contLeft: {},
  firstColumn: {},
  contRight: {},
  totalAmount: {},
  hide: {
    display: 'none'
  },
  defaultStyle: {
    padding: '10px',
    background: '#fff',
    fontFamily: data => data.fontFamily1,
    position: 'sticky',
    left: '0',
    right: '0',
    bottom: '0',
    marginTop:'auto',
    ...mixins.boxShadow('2px 0 4px 0 rgba(0, 0, 0, 0.2)'),
    '& $content': {
      maxWidth: '1180px',
      margin: '0 auto',
      display: 'table',
      width: '100%',
      '& $contLeft': {
        fontSize: '0',
        textAlign: 'justify',
        marginBottom: '7px',
        '&:after': {
          content: "''",
          display: 'inline-block',
          width: '100%'
        },
        '@media (min-width: 801px)': {
          marginBottom: '0',
          display: 'table-cell',
          verticalAlign: 'middle'
        }
      },
      '& $firstColumn': {
        position: 'relative',
        display: 'inline-block',
        verticalAlign: 'middle',
        padding: '2px 0 5px 30px',
        maxWidth: '50%',
        minHeight: '20px',
        fontSize: '13px',
        float: 'left',
        ...mixins.boxSizing('content-box'),
        '@media (min-width: 801px)': {
          padding: '0 0 0 45px',
          fontSize: '24px'
        },
        '&:lang(ar)': {
          float: 'right',
          paddingRight: '30px',
          paddingLeft: '0',
          '@media (min-width: 801px)': {
            paddingRight: '45px',
            paddingLeft: 0
          }
        }
      },
      '& $contRight': {
        position: 'relative',
        fontFamily: 'Roboto',
        '& > button': {
          width: '100%',
          height: '40px',
          '@media (min-width: 801px)': {
            height: '50px',
            maxWidth: '200px'
          }
        },
        '@media (min-width: 801px)': {
          position: 'relative',
          display: 'table-cell',
          verticalAlign: 'middle',
          textAlign: 'right',
          width: '210px',
          paddingLeft: '25px'
        },
        '&:lang(ar)': {
          '@media (min-width: 801px)': {
            textAlign: "left",
            paddingRight: "25px",
            paddingLeft: "0"
          }
        }
      },
      '& $totalAmount': {
        display: 'flex',
        flexDirection: 'column',
        textAlign: 'right',
        maxWidth: '50%',
        paddingRight: '5px',
        color: '#333',
        float: 'right',
        '& > span': {
          display: 'block'
        },
        '& > span:first-of-type': {
          order: '2',
          textTransform: 'capitalize',
          color: '#333',
          fontWeight: 'normal',
          '@media (min-width: 801px)': {
            textTransform: 'capitalize',
            color: '#333'
          }
        },
        '& > span:last-of-type': {
          font: data => '700 18px ' + data.fontFamily1,
          marginLeft: '10px',
          display: 'inline',
          color: '#000',
          order: '1',
          '@media (min-width: 801px)': {
            fontSize: '20px',
            marginLeft: '5px'
          },
          '&:lang(ar)': {
            '@media (min-width: 801px)': {
              marginRight: "5px",
              marginLeft: "5px"
            }
          }
        },
        '&:lang(ar)': {
          textAlign: "left",
          float: "left",
          paddingLeft: "5px",
          paddingRight: "0"
        }
      },
      '@media (min-width: 801px)': {
        overflow: 'hidden'
      }
    },
    '@media (min-width: 801px)': {
      padding: '20px',
    },
    '&:lang(ar)': {
      direction: 'rtl',
      textAlign: 'right'
    }
  },
  tooltipHelpContainer: {
    position: 'relative',
    zIndex: '500',
    '@media (min-width: 801px)': {
      maxWidth: '1180px',
      margin: '0 auto'
    }
  },
  hideText: {
    '&:lang(ar)': {
      display: 'none'
    }
  },
  tooltipHelp: {
    position: 'absolute',
    bottom: '102px',
    right: '0',
    left: '0',
    background: '#fc0',
    textAlign: 'center',
    ...mixins.transition(),
    padding: '10px 20px 10px 10px',
    '&:lang(ar)': {
      paddingLeft: '20px',
      paddingRight: '10px',
      '@media (min-width: 801px)': {
        right: 'auto',
        left: 0
      }
    },
    '&:after': {
      content: "''",
      right: '15px',
      borderLeft: '9px solid transparent',
      borderRight: '9px solid transparent',
      borderTop: '10px solid #fc0',
      position: 'absolute',
      top: '100%'
    },
    '@media (min-width: 801px)': {
      position: 'absolute',
      right: '0',
      left: 'auto',
      bottom: '81px',
      width: '300px'
    }
  },
  tooltipHelpCloseContainer: {
    position: 'relative'
  },
  tooltipHelpClose: {
    position: 'absolute',
    top: '-5px',
    right: '-12px',
    '&:lang(ar)': {
      right: 'auto',
      left: '-12px'
    }
  },
  robotoSummary: {
      font: '16px Roboto, sans-serif',
  },
};
